import { State } from '@progress/kendo-data-query';
import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface CheckLinkedReceiptRequest {
  companyId: string;
  body: State;
}

export interface LinkedReceiptData {
  items: any[];
  totalRecords: number;
}

async function checkLinkedReceipt({
  companyId,
  body,
}: CheckLinkedReceiptRequest): Promise<LinkedReceiptData> {
  const response = await axiosInstance.post<LinkedReceiptData>(api.filterReceipts(companyId), body);
  return response.data;
}

interface UseCheckLinkedReceiptQueryOptions {
  companyId: string;
  body: State;
  enabled?: boolean;
}

const useCheckLinkedReceiptQuery = ({
  companyId,
  body,
  enabled,
}: UseCheckLinkedReceiptQueryOptions) => {
  const query = useQuery<LinkedReceiptData>({
    queryKey: [...queryKeys.invoice.linkedReceipt(companyId, body)],
    queryFn: () => checkLinkedReceipt({ companyId, body }),
    enabled: !!companyId && !!enabled,
  });

  return query;
};

export default useCheckLinkedReceiptQuery;
